import * as React from 'react';

import { HeaderVillageContainer, isVillageInfoVisible } from './village';
import { HeaderDefaultContainer } from '../../../containers/HeaderDefaultContainer';
import { HeaderNewbuildingRedesignedContainerLoadable } from '../../../containers/HeaderNewbuildingRedesigned';
import { IJsonQuery } from '../../../json_query';
import { IDeveloperInfo, IDeveloperInfoRedesigned } from '../../../types/developerInfo';
import { INewbuilding } from '../../../types/newbuildingHeader';
import { IVillageInfo } from '../../../types/villageInfo';
import { HeaderDeveloperContainer } from '../../containers/DeveloperHeaderContainer';

export interface IHeaderProps {
  villageInfo?: IVillageInfo | null;
  jsonQuery: IJsonQuery;
  newbuildingInfo: INewbuilding | null;
  developerInfo: IDeveloperInfo | null;
  developerInfoRedesigned: IDeveloperInfoRedesigned | null;
}

export const Header: React.FC<IHeaderProps> = ({
  villageInfo,
  jsonQuery,
  newbuildingInfo,
  developerInfo,
  developerInfoRedesigned,
}) => {
  if (villageInfo && isVillageInfoVisible(villageInfo, jsonQuery)) {
    return <HeaderVillageContainer />;
  }

  if (newbuildingInfo) {
    return <HeaderNewbuildingRedesignedContainerLoadable />;
  }

  if (developerInfo || developerInfoRedesigned) {
    return <HeaderDeveloperContainer />;
  }

  return <HeaderDefaultContainer />;
};
